document.addEventListener("DOMContentLoaded", function() {
  const buttonContainer = document.querySelector('[data-preorder-check]');
  if (!buttonContainer) return; // Ensure the container exists

  const buyButton = buttonContainer.querySelector('[data-preorder-button]');
  if (!buyButton) return; // Ensure the button exists

  const preorderDate = window.preorderDate; // Ensure preorderDate is defined
  const frontend_date = window.frontend_date; // Ensure frontend_date is defined

  if (!preorderDate || typeof preorderDate !== "string") return;

  const currentDate = new Date().toISOString().split('T')[0];

  if (currentDate < preorderDate) {
    if (frontend_date && typeof frontend_date === "string") {
      buyButton.innerHTML = frontend_date;
    }
  } 
});